/** Unique tabs using h5 as an anchor **/
document.addEventListener("DOMContentLoaded", function(event) { 
  $($('.product-single__content-text').find('h5').get().reverse()).each(function(i) {
      var tabName = $(this).text();
      tabContent = '';
      //check if h5 has text inside
    if ($(this).text() != '') {
          //hide h5
        $(this).hide();
          //combine content between h5 elements
          $(this).nextUntil('h5').each(function() {
              tabContent = tabContent + this.outerHTML;
              //hide content
              $(this).hide();
          });
          //generate tab HTML
          $('.js-accordion').prepend('<div id="acc-unique-'+ [i] +'" class="product-single__accordion__item js-unique-info" style="display:none;"><div class="product-single__accordion__item-wrap rte">' + tabContent + '</div></div>');
          $('.js-accordion').prepend('<a href="#acc-unique-'+ [i] +'" class="product-single__accordion__title js-unique-trigger"><h4 class="product-single__accordion__title-text">' + tabName + '</h4><span class="product-single__accordion__title-icon icon-fallback"><i class="icon icon--plus" aria-hidden="true"></i><span class="icon-fallback__text">Open tab</span></span></a>');
      } else {  
          //hide empty h5
          $(this).hide();
      }
  });
  $(".js-unique-trigger").click(function() {
    var thisItem = $(this).attr("href");
    var activeClass = "js-active";
    //check if clicked is active
    if ($(thisItem).hasClass(activeClass)) {
      //close current item
      $(this).removeClass(activeClass);
      $(thisItem)
      .removeClass(activeClass)
      .stop()
      .slideUp();
    } else {
      //open and activate this item
      $(thisItem)
      .addClass(activeClass)
      .stop()
      .slideDown();
      $(this).addClass(activeClass);
    }
    return false;
  });
});/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...

$(document).ready(function() {
  $('.announcement-custom-section-grid').slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      infinite: true,
      dots: false,
      arrows: false,
      centerMode: true,
      centerPadding: "30px",
      autoplay: true,
      autoplaySpeed: 3000,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            fade: true,
            cssEase: 'linear',
          }
        }
      ]
  });

  $(".product-form__swatch__input-custom").on("change", function(){
   var inputsArr = $(this).closest(".js-product-form-swatch").find(".product-form__swatch__item[hidden] input");
   // debugger;
   if($(this).prop("checked") == true){
     inputsArr[1].checked = true;  
     $(inputsArr[1]).trigger("change");
   }else{
     inputsArr[0].checked = true;  
     $(inputsArr[0]).trigger("change");
   } 
  })
});



















                    